import { MapDrawerEntityForPoiMetadataByType } from 'features/mapping/mapping.types';
import { useMapDrawerEntityForPoiState } from 'state/useMapDrawerEntityForPoiState';
import { ExternalFeatureDrawerContent } from 'features/mapping/components/layers/ExternalFeatureLayer/ExternalFeatureDrawerContent';
import { PrivateLandOwnershipContent } from 'features/mapping/components/layers/PrivateLandOwnershipLayer/PrivateLandOwnershipContent';
import { OverStoryDrawerContent } from 'features/mapping/components/layers/ExternalFeatureLayer/OverstoryDrawerContent';

type ContentComponents = {
  [K in keyof MapDrawerEntityForPoiMetadataByType]: (
    props: MapDrawerEntityForPoiMetadataByType[K],
  ) => JSX.Element;
};

const MAP_DRAWER_ENTITY_CONTENT_COMPONENTS: ContentComponents = {
  privateLandOwnership: PrivateLandOwnershipContent,
  basic: ExternalFeatureDrawerContent,
  overstory: OverStoryDrawerContent,
};

export const MapDrawerEntityContentForPoi = (): JSX.Element | null => {
  const { mapDrawerEntityForPoi } = useMapDrawerEntityForPoiState();

  if (!mapDrawerEntityForPoi) {
    return null;
  }

  const { type, metadata } = mapDrawerEntityForPoi;

  const Content = MAP_DRAWER_ENTITY_CONTENT_COMPONENTS[type];

  // @ts-expect-error - metadata is guaranteed to be the correct type
  return <Content key={type} {...metadata} />;
};
